module.exports = __webpack_public_path__ + "static/img/activity_six.41830807.jpg";